import { State } from 'b2b-apps/shop/common/redux/types';
import { CoreAssortmentState } from 'b2b-apps/shop/product/redux/coreAssortment/types';

const getCoreAssortment = (state: State): CoreAssortmentState => state.product.coreAssortment;

export { getCoreAssortment };

